<template>
    <section class="main login-page">
		<section class="branding">
            <h1>Navigator</h1>
			<img src="/img/sextant.jpg">
			<p>Data <span class="icon">&#x27A4;</span> Intelligence <span class="icon">&#x27A4;</span> Direction</p>
		</section>
		<section class="content">
			<h2>Please log in</h2>
			<label>Username</label>
			<input type="text" v-model="user_name">
			<label>Password</label>
			<input type="password" v-model="password" @keyup.enter="doLogin()">
			<button class="action" @click="doLogin()">Log In</button>
            <div class="message">{{ message }}</div>

		</section>
	</section>
</template>

<script>
export default {
	name: 'login',
  	data() {
        return {
            message: '',
            user_name: '',
            password: '',
            retype_password: '',
            returnTo: '',
            showForgotPassword: false,
            temporaryPasswordSent: false,
            showResetPassword: false,
            showMarketingMessage: false
        }
    },
    created() {
        this.doLogout()
    },
    methods: {
        doLogout() {
            this.message = ''
            this.apiCall({ destination: 'logout' }).then(obj => {
                if (obj.status == 'success') {
                    sessionStorage.removeItem('user_id')
                    sessionStorage.removeItem('user_name')
                    sessionStorage.removeItem('user_type_code')
                    this.updateUser({})
                } else {
                    this.message = obj.message
                }
            })
        },
		doLogin() {
            if (!this.user_name || !this.password) return
            this.message = ''
            this.apiCall({ destination: 'login', data: { user_name: this.user_name, password: this.password }}).then(obj => {
                if (obj.status == 'success') {
                    // update sessionStorage username to preserve on browser refresh
                    this.user_name = obj.user.user_name
                    sessionStorage.setItem('user_name', this.user_name)
                    //if (obj.user.user_type_code == 'EMPLOYEE') {
                        this.$router.push({ path: 'promotions' })
                    //} else {
                        //this.$router.push({ path: 'navigator' })
                        // NOTE: beta we're defaulting to promotions
                        //this.$router.push({ path: 'promotions' })
                    //}
                } else {
                    this.message = obj.message
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
